import Tabs from '@commons/tabs'
import Column from '@components/column'
import SectionHeading from '@commons/headings/section'
import Charge from './components/charge'
import Support from './components/support'
import AppInfo from './components/appInfo'
import PaymentOptions from './components/paymentOptions'
import Logos from './components/logos'
const AdminPlatformSettingPage = () => {
  const tabs = [
    {
      title: 'Platform Charge',
      key: 'platform-charge',
      Component: Charge,
    },
    {
      title: 'Support',
      key: 'support',
      Component: Support,
    },
    {
      title: 'App Info',
      key: 'app-info',
      Component: AppInfo,
    },
    {
      title: 'Logos',
      key: 'logos',
      Component: Logos,
    },
    {
      title: 'Payment Options',
      key: 'payment-options',
      Component: PaymentOptions,
    },
  ]
  return (
    <Column>
      <Column styleColumn="margin-bottom:20px;">
        <SectionHeading title="Platform Settings" />
      </Column>
      <Tabs items={tabs} />
    </Column>
  )
}

export default AdminPlatformSettingPage
